<div *ngIf="massiveUpdate && selectedItems.length > 0" class="d-flex align-items-center gap-6">
  <span *ngFor="let item of selectedItems" class="badge badge-secondary p-1">
    {{ item.name }}
  </span>
</div>
<form
  [formGroup]="formWaterwise"
  (submit)="submitForm()"
  class="d-flex flex-column"
  style="gap: 12px"
>
  <div class="row">
    <div class="col-12" *ngIf="!massiveUpdate">
      <div>
        <div class="floating-label">
          <input
            type="text"
            class="form-control"
            formControlName="name"
            placeholder=" "
            [class.is-invalid]="
              formWaterwise.get('name')?.invalid &&
              formWaterwise.get('name')?.touched
            "
          />
          <span>{{ "tables.name" | translate }}</span>
        </div>
        <span
          class="text-danger"
          *ngIf="
            formWaterwise.get('name')?.invalid &&
            formWaterwise.get('name')?.touched
          "
        >
          {{ "admin.admins.error-name" | translate }}
        </span>
      </div>
    </div>
    <div class="col-12" *ngIf="!massiveUpdate && globalFunction.validateSoloAdmin()">
      <div class="mt-3">
        <div class="floating-label">
          <input
            type="text"
            class="form-control"
            formControlName="mac"
            placeholder=" "
            [class.is-invalid]="
              formWaterwise.get('mac')?.invalid &&
              formWaterwise.get('mac')?.touched
            "
          />
          <span>Mac</span>
        </div>
        <small> {{textMac(formWaterwise.value.mac)}}</small>
        <span
          class="text-danger d-block"
          *ngIf="
            formWaterwise.get('mac')?.invalid &&
            formWaterwise.get('mac')?.touched
          "
        >
          {{ "waterwise-form.mac-required" | translate }}
        </span>
      </div>
    </div>
    <div class="col-12 col-lg-4" *ngIf="storageService.isAdmin()">
      <div class="mt-3">
        <div class="floating-label">
          <div>
            <input
              type="text"
              class="form-control"
              formControlName="filteredBusinessName"
              placeholder=" "
              (keyup)="filterClientsList()"
            />
          </div>

          <select
            class="form-control mt-3"
            (change)="getFarms();formWaterwise.controls['pond_id'].setValue(''); cleanClientsFilteredList();"
            formControlName="client_id"
            name="client_id"
            id="client_id"
          >
            <option value="">{{'admin.admins.select-client' | translate}}</option>
            <option *ngFor="let item of filteredClients" [value]="item.id">{{ item.name }}</option>
          </select>
          <span>{{ "filter.client" | translate }}</span>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-4" *ngIf="storageService.validateSoloAdmin()">
      <div class="mt-3">
        <div class="floating-label">
          <select
            *ngIf="!loadingFarms; else loading"
            name="farm_id"
            id="farm_id"
            class="form-control"
            formControlName="farm_id"
            placeholder=" "
            (change)="getPonds();deleteLatLng();formWaterwise.controls['pond_id'].setValue('')"
          >
            <option value="">{{ "general.select-farm" | translate }}</option>
            <option *ngFor="let farm of farms" [value]="farm.id">{{farm.name}}</option>
          </select>
          <span>{{ "general.farm" | translate }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4" *ngIf="ponds.length > 0">
      <div class="mt-3">
        <div class="floating-label">
          <select
            *ngIf="!loadingPonds; else loading"
            name="pond_id"
            id="pond_id"
            class="form-control"
            formControlName="pond_id"
            placeholder=" "
            (change)="deleteLatLng()"
            [class.is-invalid]="
              formWaterwise.get('pond_id')?.invalid &&
              formWaterwise.get('pond_id')?.touched
            "
          >
            <option value="">{{ "general.select-pond" | translate }}</option>
            <option *ngFor="let pond of ponds" [value]="pond.id">{{pond.name}}</option>
          </select>
          <span>{{ "tables.pond" | translate }}</span>
        </div>
        <span
          class="text-danger"
          *ngIf="
            formWaterwise.get('pond_id')?.invalid &&
            formWaterwise.get('pond_id')?.touched
          "
        >
          {{ "clients.cycles.assign-cycle.pond-required" | translate }}
        </span>
      </div>
    </div>
    <ng-container *ngIf="formWaterwise.value.farm_id !== '' && massiveUpdate === false">
      <div class="col-12 col-lg-5">
        <div class="mt-3">
          <div class="floating-label">
            <input
              type="number"
              class="form-control"
              formControlName="lat"
              placeholder=" "
              (change)="changeInputLatLng('lat',$event.target.value)"
            />
            <span>{{ "waterwise-form.latitude" | translate }}</span>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="mt-3">
          <div class="floating-label">
            <input
              type="number"
              class="form-control"
              formControlName="lng"
              placeholder=" "
              (change)="changeInputLatLng('lng',$event.target.value)"
            />
            <span>{{ "waterwise-form.longitude" | translate }}</span>
          </div>
        </div>
      </div>
      <div class="col-1 d-flex justify-content-center align-items-end" style="font-size: 26px">
        <em
          class="fa fa-map c-pointer"
          [ngClass]="{'text-success': viewMap}"
          (click)="viewMap = !viewMap"
        ></em>
      </div>
      <div class="col-12" *ngIf="viewMap">
        <div class="mt-3 map-waterwise">
          <app-map-dynamic
            *ngIf="farm || ponds && ponds.length > 0"
            [farm]="farm"
            [list_polygon_with_feeders]="ponds"
            [marker]="selectMarker"
            [icon_marker]="'waterwise'"
            (clickMapPolygon)="clickPolygonPond($event)"
            (clickFeederMap)="dragMarket($event)"
          >
          </app-map-dynamic>
        </div>
      </div>
    </ng-container>
    <div class="col-12">
      <div class="mt-3">
        <div class="floating-label">
          <select
            name="device_type"
            id="device_type"
            class="form-control"
            formControlName="device_type"
            placeholder=" "
          >
            <option value="">{{ "waterwise-form.select-type" | translate }}</option>
            <option value="0">{{ "waterwises.device-type-drone" | translate }}</option>
            <option value="1">{{ "waterwises.device-type-station" | translate }}</option>
            <option value="2">{{ "waterwises.device-type-buoy" | translate }}</option>
          </select>
          <span>{{ "waterwise-form.hud-type" | translate }}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="mt-3">
        <div class="floating-label">
          <select
            *ngIf="!loadingBrands; else loading"
            name="brand"
            id="brand"
            class="form-control"
            formControlName="brand"
            placeholder=" "
          >
            <option value="">{{'feeder.select-brand' | translate}}</option>
            <option *ngFor="let b of brands" [value]="b.id">{{b.name}}</option>
          </select>
          <span>{{'tables.brand' | translate}}</span>
        </div>
      </div>
    </div>
  </div>
  <app-dynamic-object-builder
    [meta_data]="meta_data"
    (constructValue)="getValueMetaData($event)"
  ></app-dynamic-object-builder>

  <div class="row mt-3">
    <div class="col-12 col-md-6">
      <div class="floating-label">
        <input
          type="number"
          class="form-control"
          formControlName="warranty_months"
          min="0"
          placeholder=" "
        />
        <span>{{ "update-device-dynamic.warranty-months" | translate }}</span>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="floating-label">
        <input
          type="date"
          class="form-control"
          formControlName="warranty_start_date"
          placeholder=" "
        />
        <span>{{ "update-device-dynamic.warranty-start-date" | translate }}</span>
      </div>
    </div>
  </div>

  <div class="text-center">
    <button class="btn btn-success btn-space" type="submit">
      <app-spinner [smallLoader]="true" [spinnerColor]="'text-white'" *ngIf="loading_petition">
      </app-spinner>
      <span class="m-0" *ngIf="!loading_petition"> {{'general.finish' | translate}} </span>
    </button>
  </div>
</form>

<ng-template #loading>
  <div class="text-center">
    <app-spinner [smallLoader]="true"></app-spinner>
  </div>
</ng-template>
